import React from 'react';
import { useNavigate } from 'react-router-dom';

const About = ({ data, stats }) => {
  const navigate = useNavigate();

  // Default config if no data provided
  const config = data || {
    sectionTitle: "About Choice Network MCN",
    description: "",
    highlights: [],
    buttons: [],
    niches: []
  };

  // Safely access stats with defaults
  const safeStats = stats || { channels: 0 };

  return (
    <section id="about" className="py-16 lg:py-24 bg-slate-50">
      <div className="container mx-auto px-4 grid lg:grid-cols-2 gap-10 items-center">
        {/* Left Column - Content */}
        <div>
          <h2 className="text-3xl font-extrabold">{config.sectionTitle}</h2>
          <p className="mt-3 text-slate-700">
            {config.description}
          </p>

          {/* Highlights List */}
          <ul className="mt-4 space-y-3 text-slate-700">
            {config.highlights.map((highlight, index) => (
              <li key={index} className="flex items-start gap-2">
                <svg 
                  className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" 
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" 
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span>
                  <strong>{highlight.label}:</strong> {highlight.text}
                </span>
              </li>
            ))}
          </ul>

          {/* CTA Buttons */}
          <div className="mt-6 flex gap-3">
            {config.buttons.map((button, index) => (
              <button
                key={index}
                onClick={() => navigate(button.link)}
                className={
                  button.style === 'primary'
                    ? "px-5 py-3 rounded-xl text-white font-semibold bg-gradient-to-r from-blue-600 to-purple-600 shadow hover:shadow-lg transition-all"
                    : "px-5 py-3 rounded-xl font-semibold border-2 border-slate-300 hover:border-blue-600 transition-all inline-flex items-center"
                }
              >
                {button.text}
              </button>
            ))}
          </div>
        </div>

        {/* Right Column - Niche Channels Card */}
        <div className="lg:justify-self-end">
          <div className="bg-white rounded-2xl p-6 shadow-lg">
            <h3 className="font-bold mb-4">
              Our {safeStats.channels} {config.nichesTitle || 'Niche Channels'}
            </h3>
            <div className="grid grid-cols-2 gap-3 text-sm">
              {config.niches.map((niche, index) => (
                <div 
                  key={index}
                  className={`p-3 rounded-lg bg-${niche.color}-50`}
                >
                  {niche.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;